export default __webpack_public_path__ + "static/Tris Rating_logo-c4308c89cfed9b43fa06fa13fb9e01d9.png";